export function getYearAndMonth(startDate: Date): string {
    let now: Date = new Date();

    let yearNow: number = now.getFullYear();
    let monthNow: number = now.getMonth();

    let yearStarted: number = startDate.getFullYear();
    let monthStarted: number = startDate.getMonth();
    let monthCounter: number =0;

    let yearCounter: number = yearNow - yearStarted;

    if (monthNow >= monthStarted)
        monthCounter = monthNow - monthStarted;
    else {
        yearCounter--;
        monthCounter = 12 + monthNow - monthStarted;
    }


    return `${yearCounter}.${monthCounter}`;
}